import { useDispatch, useSelector } from 'react-redux'
import { useEffect } from 'react'
import { updateMerchants } from '../../features/merchants/merchantsSlice'
import { getClientKeyWithAccessToken } from '../../lib/security'

export const useMerchants = (setIsLoading, isLoading) => {
  const queryState = useSelector((state) => state.merchants?.filters)
  const { limit, offset, fromDate, toDate, page, id, status, type, list, title, description } = queryState
    ? queryState
    : { ...null }
  const { accessToken } = useSelector((state) => state.login)

  const dispatch = useDispatch()

  function buildUrl(baseUrl) {
    let url = `${baseUrl}?limit=${limit}&page=${page}&offset=${offset}`
    if (fromDate && toDate) url += `&fromDate=${fromDate}&toDate=${toDate}`
    if (id?.length) url += `&id=${id}`
    if (status?.length) url += `&status=${status}`
    if (type?.length) url += `&type=${type}`
    if (list?.length) url += `&list=${list}`
    if (title?.length) url += `&title=${title}`
    if (description?.length) url += `&description=${description}`

    return url
  }

  useEffect(() => {
    if (isLoading) {
      const baseUrlMerchants = `${process.env.REACT_APP_BASEURL}/admin/merchants`
      let url = buildUrl(baseUrlMerchants)

      getClientKeyWithAccessToken(accessToken)
        .then((clientKey) => {
          return fetch(process.env.REACT_APP_IS_DEMO ? '../../data/lists.json' : url, {
            method: 'GET',
            headers: {
              Authorization: `Bearer ${accessToken}`,
              'client-key': clientKey,
            },
          })
        })
        .then((res) => res.json())
        .then((res) => {
          if (res) {
            const { data, pagination } = res
            const aux = { data, pagination }
            dispatch(updateMerchants(aux))
            setIsLoading(false)
          }
        })
        .catch((error) => {
          console.error('[HOOK: useMerchants] --> ', error)
          setIsLoading(false)
        })
    }
  }, [isLoading])
}
